import { useEffect, useState } from 'react';
import { editAnswerList } from '../../../actions/fantasy-yes-no-action-types';
import { useDispatch, useSelector } from 'react-redux';
import { useLink } from 'react-router-stack';
import { getRouteObjByGame, isMatchInScheduled, isSmartPhone } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import { showToast } from '../../../actions/app-actions-types';
import MyAnswerTabWeb from './index_web';
import MyAnswerTabMWeb from './index_mWeb';

const MyAnswerTab = () => {
  const { item: matchItem = {}, gameType, language = 'en' } = useGame();
  const {
    _id: matchId = '',
    teamA = {},
    teamB = {},
    status: matchStatus,
    verified,
    gameState = 0,
    matchDelayed = false
  } = matchItem;
  const { questionsList, myAnswersList } = useSelector((state: any) => state.fantasy_yes_no);
  const dispatch = useDispatch();
  const navigate = useLink();
  const [answerList, setAnswerList] = useState([] as any);
  const [error, setError] = useState(false);
  const [insightInfoModal, setInsightInfoModal] = useState(false);
  const [insight, setInsight] = useState('');
  const [ruleModal, setRuleModal] = useState(false);
  const [yesNoVideoModal, setYesNoVideoModal] = useState(false);

  useEffect(() => {
    getQuestionList_();
    window.addEventListener('popstate', onClickBrowserBack);
    return () => {
      window.removeEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onClickBrowserBack = () => {
    setInsightInfoModal(false);
    setRuleModal(false);
    setYesNoVideoModal(false);
  };

  const getQuestionList_ = async () => {
    let result: any = questionsList[matchItem._id];
    if (!error) {
      result.sort((a: { sequence?: 0 | undefined }, b: { sequence?: 0 | undefined }) => {
        const { sequence: a_sequence = 0 } = a;
        const { sequence: b_sequence = 0 } = b;
        return a_sequence < b_sequence ? -1 : 1;
      });
      result = result.map((item: any) => {
        return { ...item, matchId, isPowerUp: false, answer: false };
      });
      setAnswerList(result);
    } else {
      setError(true);
    }
  };

  const onChange2x = (index: any) => {
    answerList[index].isPowerUp = !answerList[index].isPowerUp;
    setAnswerList([...answerList]);
  };

  const onChangeMyAnswer = (index: any) => {
    answerList[index].answer = !answerList[index].answer;
    setAnswerList([...answerList]);
  };

  const onPressInsight = (index: any) => {
    const insightData = answerList[index]?.insights || {};
    const { english = '' } = insightData;
    if (english) {
      setInsight(insightData);
      setInsightInfoModal(true);
    } else {
      dispatch(showToast('There is no data available'));
    }
  };

  const onChangeSave = () => {
    dispatch(
      editAnswerList({
        ...myAnswersList,
        [matchItem._id]: answerList
      })
    );
    dispatch(showToast('Answer updated successfully'));
    navigate.push(getRouteObjByGame(gameType)['home_tab']);
  };

  const isMatchScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onPressCloseInsight = () => {
    setInsightInfoModal(false);
  };

  const onPressDismissRule = () => {
    setRuleModal(false);
  };

  const onPressOpenRule = () => {
    setRuleModal(true);
  };

  const onPressOpenYNVideo = () => {
    setYesNoVideoModal(true);
  };

  const onPressDismissYNVideo = () => {
    setYesNoVideoModal(false);
  };

  const onCalledDeadline = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  return (
    <>
      {isSmartPhone ? (
        <MyAnswerTabMWeb
          teamA={teamA}
          teamB={teamB}
          onCalledDeadline={onCalledDeadline}
          matchStatus={matchStatus}
          verified={verified}
          matchItem={matchItem}
          isMatchScheduled={isMatchScheduled}
          gameType={gameType}
          answerList={answerList}
          onChange2x={onChange2x}
          onChangeMyAnswer={onChangeMyAnswer}
          language={language}
          onPressInsight={onPressInsight}
          insightInfoModal={insightInfoModal}
          insight={insight}
          ruleModal={ruleModal}
          onPressDismissRule={onPressDismissRule}
          yesNoVideoModal={yesNoVideoModal}
          onPressDismissYNVideo={onPressDismissYNVideo}
          onPressOpenRule={onPressOpenRule}
          onPressOpenYNVideo={onPressOpenYNVideo}
          onChangeSave={onChangeSave}
          onPressCloseInsight={onPressCloseInsight}
          questionList={questionsList[matchItem._id]}
          onPressBack={onPressBack}
        />
      ) : (
        <MyAnswerTabWeb
          teamA={teamA}
          teamB={teamB}
          onCalledDeadline={onCalledDeadline}
          matchStatus={matchStatus}
          verified={verified}
          matchItem={matchItem}
          isMatchScheduled={isMatchScheduled}
          gameType={gameType}
          answerList={answerList}
          onChange2x={onChange2x}
          onChangeMyAnswer={onChangeMyAnswer}
          language={language}
          onPressInsight={onPressInsight}
          insightInfoModal={insightInfoModal}
          insight={insight}
          ruleModal={ruleModal}
          onPressDismissRule={onPressDismissRule}
          yesNoVideoModal={yesNoVideoModal}
          onPressDismissYNVideo={onPressDismissYNVideo}
          onPressOpenRule={onPressOpenRule}
          onPressOpenYNVideo={onPressOpenYNVideo}
          onChangeSave={onChangeSave}
          onPressCloseInsight={onPressCloseInsight}
          questionList={questionsList}
        />
      )}
    </>
  );
};
export default MyAnswerTab;
